import React from 'react';
import NextImage, { StaticImageData } from 'next/image';

import { CardContainer, ImageWrapper, Text } from './AccreditationCard.styled';

export interface Props {
    text: string;
    image: {
        src: StaticImageData | string;
        alt?: string;
    };
}

const AccreditationCard: React.FC<Props> = ({ text, image }) => {
    return (
        <CardContainer>
            <Text>{text}</Text>
            <ImageWrapper>
                <NextImage
                    src={image.src}
                    alt={image.alt || ''}
                    fill
                    style={{ objectFit: 'contain' }}
                />
            </ImageWrapper>
        </CardContainer>
    );
};

export default AccreditationCard;
